module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_80.ca787cfc.gif";